import { cn } from '@/design-system/lib/utils';

interface ContentContainerProps {
  open?: boolean;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const ContentContainer = ({ open, className, children, ...rest }: ContentContainerProps) => {
  return (
    <div className={cn('tw:flex-1 tw:overflow-auto tw:z-[1] tw:pt-2', className)} {...rest}>
      {children}
    </div>
  );
};
